<div class="stepper-container  course-container">
  <div (click)="onClose()" class="course-i cursor-pointer"><i class="material-icons ms-4 ms-lg-5">close</i></div>
  <mat-stepper class="pt-2 pt-xl-3" #stepper animationDuration="300" linear  class="{{ 'last-edited-step-' + stepper.selectedIndex }}">
    <mat-step [completed]="selectedElements.length>0">
      <div class="border-class my-2"></div>
       <div class="search-cont gap-2">
        <div class="s-in form-input" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="Search..." class="form-control" [(ngModel)]="searchInput"
            (input)="onSearch($event)" (keyup.enter)="onGo()" />
        </div>
        <div class="go-b" (click)="onGo()">Go</div>
        <div class="s-item d-box " (click)="onFilterView()">
          <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
        </div>
      </div>
      <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
      <div *ngIf="isPlayListAssign">
        Notes:
        <div>1. The employees highlighted in red is currently assigned one or more courses from this playlist</div>
        <div>2. You can assign this  playlist to <span *ngIf="playListUse=='no limit'">unlimited number of</span>
           <span *ngIf="playListUse!='no limit'">{{playListUse}}</span>
           employees.</div>
      </div>  
        <div class="table-container flex-grow-1 mt-2">
          <div class="table-responsive">
            <table class=""  mat-table [dataSource]="dataSourceEmp"  #sortEmp="matSort" matSort  (matSortChange)="announceSortChange($event)" class="mat-elevation-z8 normal-td">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox name="schedule" [(ngModel)]="isSelectAll" (change)="onSelectAll($event)" [disabled]="searchInput !== '' || this.filterObj.arr.length !== 0 "> </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox name="schedule" [(ngModel)]="element.selected" (change)="onSelectSingle($event,element)"></mat-checkbox>
                </td>
              </ng-container>       
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef style="width:35%"> Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="profile-img me-2">
                      <img *ngIf="!element.profile_picture" src="assets/images/icons/employee.png" class="img-fluid"  alt="">
                      <img *ngIf="element.profile_picture" [src]="imageURL+element.profile_picture"
                      onerror="this.src='assets/images/icons/employee.png';" class="img-fluid" alt="">
      
                    </div>
                    <div class="">
                      <div>{{element.first_name}} {{element.last_name}}</div>
                      <div class="steel-blue">{{element.email}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>    
               <ng-container matColumnDef="department">
                <th mat-header-cell *matHeaderCellDef>Department</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.department"> {{ element.department }}</span>
                  <span *ngIf="!element.department">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="phone_number">
                <th mat-header-cell *matHeaderCellDef>Phone Number</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.phone_number">{{ element.phone_number }}</span>
                  <span class="text-bold" *ngIf="!element.phone_number">-</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsEmp"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsEmp" [ngClass]="row.a_s==1 ? 'course-assign':''"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSourceEmp.data.length == 0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid"alt="" />
            </div>
       
          </div>
          
          <div class="pagination-cont" *ngIf="dataSourceEmp.data.length!=0">
            <div class="show-item">
              {{"COMMON.SIP" | translate}}
              <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                [(ngModel)]="config.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="page-c">            
              <ngb-pagination [collectionSize]="countEmp" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
          </div>
        </div>
        <div class="text-end bottom-content">
          <div>
            <mat-error *ngIf="isFirstStepClicked && selectedElements.length==0" >Please select employee to proceed</mat-error>
          </div>       
          <button  mat-raised-button color="primary"  class="auth-form-btn mt-1 no-sh-btn" type="submit" (click)="onFirstNextClick()"> Next </button>
        </div>     
    </mat-step>
    <mat-step [completed]="assignFormGroup.valid">
      <div class=" table-container justify-content-center">
      <form [formGroup]="assignFormGroup" class="text-center " style="overflow-y: auto;">
        <div class="row m-0 ">
          <div class="col-12 col-lg-6">
            <div class="box-item h-100">
              <div class="text-left">
                <mat-radio-group formControlName="isPublish">
                  <mat-radio-button class="example-margin " value="1">Publish now</mat-radio-button >
                  <mat-radio-button class="example-margin" value="0">Schedule Publish</mat-radio-button>
                </mat-radio-group>
              </div>              
              <div class=" d-flex align-items-center ps-3 flex-wrap flex-md-nowrap "  *ngIf="assignFormGroup.get('isPublish')?.value == '0'">
           
                <div class="in-box me-2 flex-grow-1 mt-1">
                  <input class="form-control" [matDatepicker]="publishDate" formControlName="training_date" [min]="minDate" placeholder="Select Date"/>
                  <mat-datepicker-toggle matIconSuffix [for]="publishDate" ></mat-datepicker-toggle>
                  <mat-datepicker #publishDate></mat-datepicker>
                </div>
                <div class="in-time-box mt-3">
                  <i class="material-icons">access_time</i>
                  <input  class="form-control" [ngxTimepicker]="fullTime" [format]="24" readonly formControlName="training_time" />
                  <ngx-material-timepicker #fullTime></ngx-material-timepicker>
                </div>
              </div>  
              <div *ngIf="getControls.training_date.touched && getControls.training_date.invalid">
                <mat-error *ngIf="getControls.training_date.errors && getControls.training_date.errors['required']" class="ps-2 text-left">
                  This is required</mat-error>
              </div>
              <div *ngIf="getControls.training_time.touched && getControls.training_time.invalid">
                <mat-error *ngIf="getControls.training_time.errors && getControls.training_time.errors['required'] &&  !getControls.training_date.errors"
                class="ps-2 text-left">
                  This is required</mat-error>
              </div>                    
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-0">
            <div class="box-item h-100 ">
              <div class="text-left">
                <mat-radio-group formControlName="isManager">
                  <mat-radio-button class="example-margin " value="1">Select Manager</mat-radio-button >
                  <mat-radio-button class="example-margin" value="0">Select Department</mat-radio-button >
                </mat-radio-group>
              </div>             
              <div class="mt-3 ps-3 d-flex align-items-center flex-column">
                <select class="form-control" *ngIf="assignFormGroup.get('isManager')?.value == '1'" formControlName="manager_id" >
                  <option value="">Select</option>
                  <option  [value]="item.manager_id" *ngFor="let item of managerArr">
                    {{ item.first_name }}{{ item.last_name }}
                  </option>
                </select>
                <div class="w-100 text-left">
        
                  <mat-select multiple formControlName="department_id" class="form-control" placeholder="Select Department"  *ngIf="assignFormGroup.get('isManager')?.value == '0'">
                    <mat-option *ngFor="let data of departmentArr"
                        [value]="data.id">
                        {{ data.dep }}
                    </mat-option>
                </mat-select>
                </div>
                <div *ngIf="getControls.manager_id.touched && getControls.manager_id.invalid" class="me-auto">
                  <mat-error *ngIf="getControls.manager_id.errors && getControls.manager_id.errors['required']">
                    This is required </mat-error>
                </div>
                <div *ngIf="getControls.department_id.touched && getControls.department_id.invalid" class="me-auto">
                  <mat-error *ngIf="getControls.department_id.errors && getControls.department_id.errors['required']">
                    This is required </mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0 ">
          <div class="col-12 col-lg-6 mt-3 mt-lg-4">
            <div class="box-item   h-100">
              <div class="text-wrap text-left ps-3">{{ "Deadline Date" | translate }}</div>
              <div class="in-box me-2 flex-grow-1 mt-3 ms-3">
                <input class="form-control" [matDatepicker]="deadlineDate" formControlName="deadline_date"  [min]="minDate"/>
                <mat-datepicker-toggle matIconSuffix [for]="deadlineDate" ></mat-datepicker-toggle>
                <mat-datepicker #deadlineDate ></mat-datepicker>
              </div>
              <div *ngIf="getControls.deadline_date.touched && getControls.deadline_date.invalid">
                <mat-error *ngIf="getControls.deadline_date.errors && getControls.deadline_date.errors['required']" class="text-left ps-3">
                  This is required</mat-error>
              </div>                               
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-4 ">
            <div class="box-item  h-100" >
              <div class="text-left">
                <mat-checkbox name="schedule" formControlName="isSendReminder">
                  <div class="text-wrap"> {{ "Send a reminder if user didn't view by" | translate }} </div>
                </mat-checkbox>
              </div>  
              <div class="mt-1 d-flex align-items-center flex-wrap gap-2 flex-sm-wrap ps-2">              
                <div class="in-box me-2 flex-grow-1">
                  <input class="form-control" [matDatepicker]="remindDate" formControlName="reminder_date" [min]="minDate"/>
                  <mat-datepicker-toggle matIconSuffix [for]="remindDate" ></mat-datepicker-toggle>
                  <mat-datepicker #remindDate></mat-datepicker>
                </div>
                <div class="in-time-box mt-1 mt-sm-0">
                  <i class="material-icons">access_time</i>
                  <input  class="form-control" [ngxTimepicker]="fullRTime" [format]="24" readonly formControlName="reminder_time"/>
                  <ngx-material-timepicker #fullRTime></ngx-material-timepicker>
                </div>
              </div>    
              <div *ngIf="getControls.reminder_date.touched && getControls.reminder_date.invalid">
                <mat-error *ngIf="getControls.reminder_date.errors && getControls.reminder_date.errors['required']" class="ps-2 text-left">
                  This is required</mat-error>
              </div>
              <div *ngIf="getControls.reminder_time.touched && getControls.reminder_time.invalid">
                <mat-error *ngIf="getControls.reminder_time.errors && getControls.reminder_time.errors['required'] &&  !getControls.reminder_date.errors"
                class="ps-2 text-left">
                  This is required</mat-error>
              </div>                                       
            </div>
          </div>
        </div>
        <div class="row m-0  ">
          <div class="col-12 col-lg-6 mt-3 mt-lg-4">
            <div class="box-item h-100 ">
              <div class="text-left">
                <mat-checkbox name="schedule" formControlName="isScheduleRemoval">
                  <div class="text-wrap">  {{ "Schedule removal from the app" | translate }} </div>
                </mat-checkbox>
              </div>              
              <div class=" d-flex align-items-center flex-wrap gap-2 ps-3">
                <div class="in-box me-2 flex-grow-1 mt-1 ">
                  <input class="form-control" [matDatepicker]="removeDate" formControlName="remove_date" [min]="minDate"/>
                  <mat-datepicker-toggle matIconSuffix [for]="removeDate" ></mat-datepicker-toggle>
                  <mat-datepicker #removeDate></mat-datepicker>
                </div>
                <div class="in-time-box mt-1 ">
                  <i class="material-icons">access_time</i>
                  <input  class="form-control" [ngxTimepicker]="removeTime" [format]="24" readonly  formControlName="remove_time"/>
                  <ngx-material-timepicker #removeTime></ngx-material-timepicker>
                </div>
              </div>  
              <div *ngIf="getControls.remove_date.touched && getControls.remove_date.invalid">
                <mat-error *ngIf="getControls.remove_date.errors && getControls.remove_date.errors['required']">This is required</mat-error>
              </div>
              <div *ngIf="getControls.remove_time.touched && getControls.remove_time.invalid">
                <mat-error *ngIf="getControls.remove_time.errors && getControls.remove_time.errors['required'] &&  !getControls.remove_date.errors">
                  This is required</mat-error>
              </div>           
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-lg-4 ">
            <div class="box-item  h-100  text-left">
              <mat-checkbox name="schedule" formControlName="isNotifyEmployee">
                <div class="text-wrap">  {{ "Notify employees via push notification" | translate }}</div>
              </mat-checkbox>
              <div class="mt-1 d-flex align-items-center ps-2">
                <input class="form-control"  type="text"  formControlName="notification_msg" />
              </div>
              <div *ngIf="getControls.notification_msg.touched && getControls.notification_msg.invalid">
                <mat-error *ngIf="getControls.notification_msg.errors && getControls.notification_msg.errors['required']" class="ps-2 text-left">
                  This is required</mat-error>
              </div>
            </div>
          </div>
        </div>
      </form>    
       </div>
       <div class="d-flex align-items-center justify-content-end   bottom-content">
        <button mat-stroked-button matStepperPrevious class="auth-form-btn outline-btn mt-1">Back</button>
        <button mat-raised-button color="primary" matStepperNext class="auth-form-btn  mt-1 ms-3" (click)="onAssignSubmit()">Next</button>
      </div>
    </mat-step>
    <mat-step>
      <div class=" table-container justify-content-center">
      <div class="summary-container ">
        <div class="text-center asset-img mt-2">
          <img src="assets/images/object_icons/assign_course.png"  class="img-fluid"/>
        </div>
        <h5 class="my-lg-4 my-3 text-center">{{"Your Asset is ready to go!!"|translate}}</h5>
        <div class="row">
          <div class="col-sm-6 mt-1 mt-sm-2 mt-lg-3 grey-txt">{{"Asset will be assigned to"|translate}}: </div>
          <div class="col-sm-6 ps-lg-5 mt-1 mt-sm-2 mt-lg-3 text-black">{{selectedElements.length}} users</div>
        </div>
        <div class="row">
          <div class="col-sm-6 mt-1 mt-sm-2 mt-lg-3 grey-txt">{{"Asset will be published on"|translate}}: </div>
          <div class="col-sm-6 ps-lg-5 mt-1 mt-sm-2 mt-lg-3 text-black"> 
            {{assignFormGroup.get('training_date')?.value | date: "dd/MM/yyyy" }} at {{assignFormGroup.get('training_time')?.value}}
          </div>
        </div>
        <div class="row" *ngIf="assignFormGroup.get('remove_date')?.value">
          <div class="col-sm-6 mt-1 mt-sm-2 mt-lg-3 grey-txt"> {{"Asset will be removed on"|translate}}:</div>
          <div class="col-sm-6 ps-lg-5 mt-1 mt-sm-2 mt-lg-3 text-black">   
            {{assignFormGroup.get('remove_date')?.value  | date: "dd/MM/yyyy" }} at {{assignFormGroup.get('remove_time')?.value}} </div>
        </div>
        <div class="mt-3 mt-xl-5 grey-txt" *ngIf="assignFormGroup.get('notification_msg')?.value">Users will be notified:</div>
        <div class="notify-box d-box text-black mt-2 mt-lg-3"  *ngIf="assignFormGroup.get('notification_msg')?.value">
           "{{ assignFormGroup.get('notification_msg')?.value }}" </div>
      </div>
    </div>     
    <div class="d-flex align-items-center  justify-content-end  bottom-content">
        <button mat-stroked-button matStepperPrevious class="auth-form-btn outline-btn mt-1">Back</button>
        <button mat-raised-button color="primary" matStepperNext class="auth-form-btn mt-1  ms-3" (click)="onSubmitAssign()">Submit</button>
      </div>
    </mat-step>
    <ng-template matStepperIcon="edit" let-index="index">
      <div class="step-number">{{ index + 1 }}</div>
    </ng-template>
  </mat-stepper>
</div>
<app-loading-spinner></app-loading-spinner>